import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'
import Auth from './packages/auth/Auth.js'
import Permission from './packages/auth/Permission.js'
// import notif from './packages/notification/notification.js'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import french from 'vee-validate/dist/locale/fr'
import store from './components/store/DataStore'
import VueI18n from 'vue-i18n'
import translateFR from './frTranslate.json'
import VueGtm from 'vue-gtm'
// import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Loading } from 'element-ui'
import VueLazyLoad from 'vue-lazyload'
/* import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour) */
const isProd = process.env.NODE_ENV === 'production'
Vue.use(VueLazyLoad)
Vue.use(Loading.directive)
Vue.use(VueGtm, {
  id: 'GTM-NHKSVTS',
  defer: true,
  enabled: isProd,
  debug: !isProd,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false
})
Vue.prototype.$loading = Loading.service
window.store = store
Vue.config.productionTip = false
// Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(VeeValidate, {fieldsBagName: 'formFields', locale: 'fr', dictionary: { fr: french }})
Vue.use(Vuex)
Vue.use(Auth)
Vue.use(Permission)
// Vue.use(notif)
window.axios = axios
Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1)
  }
})
const messages = {
  fr: translateFR
}
const i18n = new VueI18n({
  locale: 'fr',
  messages
})
axios.defaults.baseURL = process.env.API_URL
router.beforeResolve((to, from, next) => {
  if (to.name) {
  }
  next()
})
// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })
    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')
    return tag
  })
    .forEach(tag => document.head.appendChild(tag))

  // Add the meta tags to the document head.
  next()
})
router.beforeEach((to, from, next) => {
  store.commit('GET_TOKEN')
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.token
  if (to.path === '/404') {
    store.commit('SHOW_NOT_FOUND', true)
  } else {
    store.commit('SHOW_NOT_FOUND', false)
  }
  /* les liens qui mene vers l'administration */
  if (to.matched.some(record => record.meta.forVisitors)) {
    // login est une page special
    if (to.path === '/') {
      store.commit('SET_HOME_MENU', true)
    } if (to.path !== '/') {
      store.commit('SET_HOME_MENU', false)
    }
    if (to.path === '/listentreprise' | to.path === '/listappeloffre') {
      // store.commit('FULL_WIDTH', true)
    } else {
      store.commit('FULL_WIDTH', false)
    }
    if (to.path === '/') {
      store.commit('ADD_TITLE', false)
    } else {
      store.commit('ADD_TITLE', true)
    }
    if (to.path === '/login' || to.path === '/register' || to.path === '/renvoiemail' || to.path === '/smsvalidation') {
      store.commit('SHOW_FRONT', false)
    } else {
      store.commit('SHOW_FRONT', true)
      store.commit('SHOW_LOGIN', false)
      store.commit('SHOW_REGISTER', false)
      store.commit('SHOW_RENVOIEMAIL', false)
      store.commit('SHOW_SMSVALIDATION', false)
    }
    if (to.path === '/register') {
      store.commit('SHOW_REGISTER', true)
    } else {
      store.commit('SHOW_REGISTER', false)
    }
    if (to.path === '/login') {
      store.commit('SHOW_LOGIN', true)
    } else {
      store.commit('SHOW_LOGIN', false)
    }
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (Vue.auth.isAuthenticated()) {
      if (to.path === '/login' | to.path === '/register') {
        next({
          path: '/profil'
        })
      } else {
        next()
      }
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.forAuth)) {
    if (to.path === '/renvoiemail') {
      store.commit('SHOW_RENVOIEMAIL', true)
      store.commit('SHOW_SMSVALIDATION', false)
      store.commit('SHOW_FRONT', false)
    } else if (to.path === '/smsvalidation') {
      store.commit('SHOW_SMSVALIDATION', true)
      store.commit('SHOW_RENVOIEMAIL', false)
      store.commit('SHOW_FRONT', false)
    } else {
      store.commit('SHOW_FRONT', true)
      store.commit('SHOW_RENVOIEMAIL', false)
      store.commit('SHOW_SMSVALIDATION', false)
      store.commit('SHOW_LOGIN', false)
    }
    let status = parseInt(Vue.auth.getStatusCompte())
    if (!Vue.auth.isAuthenticated()) {
      next({
        path: '/login'
      })
    } else if (Vue.auth.isAuthenticated() && status === 0) {
      next({
        path: '/smsvalidation'
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
  // on traite dans cette partie les droits acces au options
  if (to.matched.some(record => record.meta.forAdminTeam)) {
    // si user n'est pas administrateur d'une team
    if (!Vue.auth.isAuthenticated()) {
      next({
        path: '/login'
      })
    } else {
      next() // make sure to always call next()!
    }
  }
})
const vm = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (typeof error.response === 'undefined') {
    // network error
    vm.$notify({
      title: 'Erreur réseau',
      message: 'Vérifier votre connexion à internet',
      type: 'error',
      duration: 10 * 1000
    })
  } else {
    if (error.response.status === 403) {
      switch (error.response.data.account_status) {
        case 0:
          router.push('/smsvalidation')
          break
        case 1:
          if (router.app._route.path !== '/verificationemail' && !router.app._route.meta.forVisitors) {
            router.push('/verificationemail')
          }
          break
        case 403:
          router.push('/login')
          break
      }
    }
    if (error.response.status === 401) {
      if (!store.state.header.showLogin) {
        Vue.auth.destroyToken()
        router.push('/login')
      }
    }
    if (error.response.status === 404) {
      router.push('/404')
    }
  }
  // alert(response)
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/main.js